<template>
  <v-form
    v-if="!ameiUser"
    lazy-validation
    @submit.prevent="onLogin"
    id="loginForm"
    ref="form"
  >
    <v-card-text class="forms">
      <v-text-field
        label="Usuário (e-mail)"
        name="login"
        type="text"
        v-model="payload.email"
        :rules="userRules"
        required
        background-color="white"
        solo
        hide-details="auto"
        class="mb-6"
      ></v-text-field>
      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye-off"
        @click:append="showNewPassword = true"
        hide-details="auto"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye"
        @click:append="showNewPassword = false"
        hide-details="auto"
      ></v-text-field>
    </v-card-text>
    <hr />

    <v-card-actions>
      <v-row>
        <v-col>
          <div class="text-center mb-3">
            <v-btn
              color="primary"
              :style="{
                backgroundColor:
                  isGov || isTur
                    ? '#5a5454 !important'
                    : isSala
                    ? '#284395 !important'
                    : '#5a5454',
              }"
              type="submit"
              id="btnEntrar"
            >
              Entrar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions class="naoSabeSenha">
      <v-row>
        <v-col>
          <div class="text-center text">
            NÃO SABE SUA SENHA?
            <div class="mt-2">
              <v-btn color="azulescurosc" :href="'#/auth/lost-password'">
                <span
                  class="cliqueAqui"
                  :style="{
                    color: '#fff !important',
                  }"
                  >CLIQUE AQUI</span
                >
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
  <div v-else>
    <Loader :is-visible="true" text="Carregando..." />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Auth from "@/Auth.js";
import { configuracoesAPI } from "@/modules/configuracao";
import { groupsPermissionAPI } from "@/modules/groups";
import Loader from "@/components/Loader";
export default {
  components: {
    Loader,
  },
  computed: {
    ...mapGetters([
      "token",
      "forcedLogout",
      "isAT",
      "isSala",
      "isGov",
      "isTur",
    ]),
    ameiUser() {
      return window.ameiUser;
    },
  },
  data() {
    return {
      payload: {},
      passwordRules: [(v) => !!v || "O campo senha é obrigatório"],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      valid: true,
      expired: Auth.getItem("expired"),
      lastRoute: Auth.getItem("last_route") || null,
      showNewPassword: false,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setConfig",
      "setUser",
      "setIsLogged",
      "setLoading",
      "setUf",
      "setAnalista",
      "setAD",
      "setForcedLogout",
      "setFullAdmin",
      "setGroupsConfig",
    ]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onLogin() {
      var isValid = !!window.ameiUser || (await this.check());

      if (!isValid) return;
      this.setLoading(true);
      this.$http
        .post("api/login", this.payload)
        .then(async ({ data }) => {
          if (data.user) {
            delete data.user.senha;
            const mappedUser = {
              ...data.user,
              permissoes: data.user.permissoes.map((item) => ({
                ...item,
                municipio: {},
              })),
            };

            this.setUser(mappedUser);

            this.setForcedLogout(false);
            if (data.user.email === "admin@admin.com.br")
              this.setFullAdmin(true);

            this.setToken(data.accessToken);

            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.token}`;

            const config = await configuracoesAPI.get();
            const groupPermission = await groupsPermissionAPI.getByGroup(
              data.user.grupo.usuarioGrupoId
            );

            var uf = config.data.filter((item) => item.nome === "sigla")[0]
              .valor;

            const configData = config.data.filter(
              (item) => item.configuracaoId == 1
            )[0];

            delete configData.relatorioFinal;
            this.setConfig(configData);
            this.setGroupsConfig(groupPermission.data);

            this.$notification.success("Logado com sucesso!", { timer: 3 });
            this.$forceUpdate();
            if (
              this.expired === true &&
              this.forcedLogout === false &&
              this.lastRoute !== "/auth/login"
            ) {
              Auth.setItem("expired", false);
              this.$router.push(this.lastRoute);
            } else {
              this.$router.push("/cidade");
            }
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
          }
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.usuarioBloqueado) {
            this.$notification.error(err.response.data.message, {
              timer: 10,
            });
          } else if (err.response && err.response.data.credencialErrada) {
            this.$notification.error(
              "Por gentileza, verifique as credenciais digitadas",
              { timer: 5 }
            );
          } else {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
          }
          this.setForcedLogout(true);
        });
    },
  },
  mounted() {
    if (window.ameiUser) {
      this.payload = {
        email: window.ameiUser.email,
        senha: window.ameiUser.sid,
      };
      this.onLogin();
    }
  },
};
</script>
<style lang="scss" scoped>
#loginForm {
  padding-bottom: 10px;
}
.naoSabeSenha {
  color: #333333;
  font-weight: bold;
  background: #aeaeae8c;
  border-radius: 10px;
  filter: brightness(1.3);
  margin: 0 1rem;
}

.text {
  a {
    white-space: normal;
  }
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #f0f0f0;
  margin: 10px;
}

.forms {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
}

@media screen and (max-width: 760px) {
  .text-right {
    .textos {
      font-size: 12px;
    }
  }
}
</style>
